<div class="modal-header">
  <h5 class="modal-title" [innerHTML]="purify(title)"></h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="reject()"></button>
</div>
<div class="modal-body" [innerHTML]="purify(message)"></div>
<div class="modal-footer">
  <button type="button" class="btn btn-link" (click)="reject()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
</div>